import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import CollectionDetails from './pages/CollectionDetails';
import Collections from './pages/Collections';
import Home from './pages/Home';
import IntegrationDetails from './pages/IntegrationDetails';
import Integrations from './pages/Integrations';
import OfferDetails from './pages/OfferDetails';
import Offers from './pages/Offers';
import * as routes from './routes';

const Toolbox: FC = () => (
  <Switch>
    <Route component={Home} exact path={routes.root} />

    <Route component={Collections} exact path={routes.collections} />
    <Route component={CollectionDetails} path={routes.collection} />

    <Route component={Integrations} exact path={routes.integrations} />
    <Route component={IntegrationDetails} path={routes.integration} />

    <Route component={Offers} exact path={routes.offers} />
    <Route component={OfferDetails} path={routes.offer} />

    <Route path="*">
      <Redirect to={routes.root} />
    </Route>
  </Switch>
);

export default Toolbox;
